import React from 'react';

export const PlayIcon = () => {
  return (
    <span style={{ position: 'absolute', right: '50%', top: '50%', transform: 'translate(50%,-50%)' }}>
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="13" cy="13" r="13" fill="#EBEEF2" />
        <path d="M18 12.5L9.75 16.3971L9.75 8.60289L18 12.5Z" fill="#212B36" />
      </svg>
    </span>
  );
};
